import styled from '@emotion/styled';
import Icon from '@icon/Icon';
import PropTypes from 'prop-types';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const ToggleShowNav = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon {...rest} viewBox="0 0 24 24">
      <path
        d="M19.7778 2H4.22222C2.99492 2 2 2.99492 2 4.22222V19.7778C2 21.0051 2.99492 22 4.22222 22H19.7778C21.0051 22 22 21.0051 22 19.7778V4.22222C22 2.99492 21.0051 2 19.7778 2Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 2V22"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 6.5H5.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10.5H5.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 14.5H5.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 12L18.0303 11.4697C18.3232 11.7626 18.3232 12.2374 18.0303 12.5303L17.5 12ZM16.0303 14.5303C15.7374 14.8232 15.2626 14.8232 14.9697 14.5303C14.6768 14.2374 14.6768 13.7626 14.9697 13.4697L16.0303 14.5303ZM14.9697 10.5303C14.6768 10.2374 14.6768 9.76256 14.9697 9.46967C15.2626 9.17678 15.7374 9.17678 16.0303 9.46967L14.9697 10.5303ZM18.0303 12.5303L16.0303 14.5303L14.9697 13.4697L16.9697 11.4697L18.0303 12.5303ZM16.9697 12.5303L14.9697 10.5303L16.0303 9.46967L18.0303 11.4697L16.9697 12.5303Z"
        fill={color}
      />
    </StyledIcon>
  );
};

ToggleShowNav.propTypes = {
  color: PropTypes.string.isRequired
};

export default ToggleShowNav;
